<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование города" : "Добавление города"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='model'
            label='Опубликовать'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='model.name'
            label='Название'
          )
        v-flex(xs12)
          s-address-suggest(
            @change='onAddressSuggestChange'
          )
        v-flex(xs12 sm6)
          v-text-field(
            :error='errors.has("geo_lat")'
            :error-messages='errors.first("geo_lat")'
            v-model='geo_lat'
            label='Широта'
          )
        v-flex(xs12 sm6)
          v-text-field(
            :error='errors.has("geo_lon")'
            :error-messages='errors.first("geo_lon")'
            v-model='geo_lon'
            label='Долгота'
          )
        v-flex(xs12)
          s-managers-list(
            v-if="id"
            :list='model.managers'
            :attributes='attributes'
            :cityId='id'
            @update='updateItem'
            @delete='deleteManager'
            @add='addManager'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import http from '@/http'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    model: {},
    attributes: {},
    geo_lat: null,
    geo_lon: null
  }),

  async created() {
    this.fetchAttributes()
    if (this.id===undefined) {
      this.model.published = true
      return
    }
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
      this.geo_lat = this.model.geo_lat
      this.geo_lon = this.model.geo_lon
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/development/cities/attributes')
        this.attributes = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async onSave() {
      this.model.geo_lat = this.geo_lat
      this.model.geo_lon = this.geo_lon
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Development.Cities' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    _parseResponse(response) {
      try {
        return JSON.parse(response)
      } catch (e) {
        throw e
      }
    },

    vError(index, key) {
      if (this.bErrors[index] && this.bErrors[index][key]) {
        return this.bErrors[index][key]
      }
    },

    onAddressSuggestChange({ data }) {
      this.geo_lat = data.geo_lat
      this.geo_lon = data.geo_lon
    },

    async deleteManager(id) {
      if (!id) return
      if (await this.$confirm('Удалить менеджера?')) {
        try {
          await http.delete(`/development/cities/${this.id}/managers/${id}`)
          this.updateItem()
        } catch(error) {
          this.$root.showSnack('Ошибка добавления менеджера')
        }
      }
    },

    async addManager(managerId) {
      if (!managerId) return
      try {
        await http.post(`/development/cities/${this.id}/managers/${managerId}`)
        this.updateItem()
      } catch(error) {
        this.$root.showSnack('Ошибка добавления менеджера')
      }
    },

    ...mapActions('development/cities', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    ...mapGetters('development/cities', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
